import Model from 'models/Model';

export default class PermissionTranslation
  extends Model<Model.IPermissionTranslation>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IPermissionTranslation>
{
  id: number;
  languageIsoCode?: Locale.Languages;
  name?: string;
  description?: string;

  constructor(
    data: Partial<Model.IPermissionTranslation> | Utils.FormData<Model.IPermissionTranslation>,
    language?: Locale.Languages
  ) {
    super({}, language);
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.name || this.id.toString(),
      subtitle: this.description,
    };
  }
}
